import { render, staticRenderFns } from "./packing-detail-form.vue?vue&type=template&id=35f0738a&scoped=true"
import script from "./packing-detail-form.vue?vue&type=script&lang=ts"
export * from "./packing-detail-form.vue?vue&type=script&lang=ts"
import style0 from "./packing-detail-form.vue?vue&type=style&index=0&id=35f0738a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0738a",
  null
  
)

export default component.exports